import React, { PureComponent, Fragment } from 'react';
import { Grid } from 'react-bootstrap';
import { Image } from '@components/common';

class Header extends PureComponent {
	render() {
		return (
			<Fragment>
				<div className="bg-primary padding-top-10 padding-bottom-10">
					<Grid>
						<div className="flex flex-align-items-center flex-justify-content-space-between">
							<div>
								<Image
									className="height-35 margin-right-20"
									src="/images/logo.png"
								/>
								<span className="hidden-xs">Your Off-Duty Officer Hiring Platform</span>
							</div>
							<div>
								<span className="margin-right-30 hidden-xs">Already have an account?</span>
								<a href="/login" className="color-white">Sign In</a>
							</div>
						</div>
					</Grid>
				</div>
			</Fragment>
		);
	}
}

export default Header;
